import { HttpClient } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { AccountService } from '../../../services/account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../services/account.service";
export class EmpreiteiraService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getEmpreiteiras() {
        return this.http.get(`${SCAMP_API.accountApiV1}/empreiteiras-cb`, { headers: this.account.composeHeaders() });
    }
    create(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/empreiteira`, data, { headers: this.account.composeHeaders() });
    }
    read(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/empreiteira/${id}`, { headers: this.account.composeHeaders() });
    }
    update(id, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/empreiteira/${id}`, data, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/empreiteira/${id}`, { headers: this.account.composeHeaders() });
    }
    list() {
        return this.http.get(`${SCAMP_API.accountApiV1}/empreiteiras`, { headers: this.account.composeHeaders() });
    }
    isUniqueNomeEmpreiteira(nome) {
        return this.http.post(`${SCAMP_API.accountApiV1}/nome-empreiteira-is-unique`, { nome }, { headers: this.account.composeHeaders() });
    }
}
EmpreiteiraService.ngInjectableDef = i0.defineInjectable({ factory: function EmpreiteiraService_Factory() { return new EmpreiteiraService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: EmpreiteiraService, providedIn: "root" });
